import React, { useState, useEffect } from 'react';
import {
  FaTimes,
  FaTrash
} from 'react-icons/fa';
import Modal from './Modal';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, itemName }) => {
  const [text, setText] = useState('');

  useEffect(() => {
    if (open) setText('');
  }, [open]);

  const canDelete = text === itemName;

  return (
    <Modal open={open} onClose={onClose} title={`Delete ${itemName}`}>
      <div className="space-y-4">
        <p className="text-sm text-gray-700">
          Type <span className="font-semibold">{itemName}</span> to confirm deletion.
        </p>
        <input
          className="input-field w-full"
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder={itemName}
        />
        <div className="flex flex-wrap justify-end gap-2 pt-2">
          <button onClick={onClose} className="btn-outline"><FaTimes />{' '}Cancel</button>
          <button
            onClick={onConfirm}
            disabled={!canDelete}
            className="btn-danger disabled:opacity-50"
          >
            <FaTrash />
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
